/**
 * Centralized session ID management
 */
import { v4 } from 'uuid';

/**
 * Generate session ID using the same logic as in LogAction.js
 * @returns {string} The session ID
 */
export const getSessionId = () => {
  return window.TRACE_ID === '%TRACE-ID%' ? v4() : window.TRACE_ID;
};

// Generate the session ID once when this module loads
export const sessionId = getSessionId();
